export const RSS_ARTICLES_REQUEST = 'RSS_ARTICLES_REQUEST'
export const RSS_ARTICLES_SUCCESS = 'RSS_ARTICLES_SUCCESS'
export const RSS_ARTICLES_FAIL    = 'RSS_ARTICLES_FAIL'

// RSS Feed Management (Admin)
export const RSS_FEEDS_LIST_REQUEST   = 'RSS_FEEDS_LIST_REQUEST'
export const RSS_FEEDS_LIST_SUCCESS   = 'RSS_FEEDS_LIST_SUCCESS'
export const RSS_FEEDS_LIST_FAIL      = 'RSS_FEEDS_LIST_FAIL'

export const RSS_FEED_CREATE_REQUEST  = 'RSS_FEED_CREATE_REQUEST'
export const RSS_FEED_CREATE_SUCCESS  = 'RSS_FEED_CREATE_SUCCESS'
export const RSS_FEED_CREATE_FAIL     = 'RSS_FEED_CREATE_FAIL'

export const RSS_FEED_UPDATE_REQUEST  = 'RSS_FEED_UPDATE_REQUEST'
export const RSS_FEED_UPDATE_SUCCESS  = 'RSS_FEED_UPDATE_SUCCESS'
export const RSS_FEED_UPDATE_FAIL     = 'RSS_FEED_UPDATE_FAIL'

export const RSS_FEED_DELETE_REQUEST  = 'RSS_FEED_DELETE_REQUEST'
export const RSS_FEED_DELETE_SUCCESS  = 'RSS_FEED_DELETE_SUCCESS'
export const RSS_FEED_DELETE_FAIL     = 'RSS_FEED_DELETE_FAIL'
